import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ShoppingBag, Search, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { itemCount, setDrawerOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  const leftLinks = [
    { to: '/shop', label: 'Shop' },
    { to: '/barks', label: 'Barks' },
    { to: '/build-a-box', label: 'Curate a Box' },
  ];
  const rightLinks = [
    { to: '/crunch', label: 'The Crunch' },
    { to: '/about', label: 'The House' },
  ];
  const allLinks = [{ to: '/', label: 'Home' }, ...leftLinks, ...rightLinks];

  return (
    <>
    <header className="sticky top-0 z-40 bg-[#f6efe1]/90 backdrop-blur-md border-b border-[#1a120b]/10">
      <div className="container-lux flex items-center justify-between h-20">
        <div className="flex items-center gap-8">
          <button className="md:hidden" onClick={() => setMobileOpen(true)} aria-label="Menu">
            <Menu className="w-5 h-5" />
          </button>
          <nav className="hidden md:flex items-center gap-8">
            {leftLinks.map((l) => (
              <NavLink key={l.to} to={l.to} className={({ isActive }) => `nav-link tracking-luxe text-[#1a120b]/85 hover:text-[#1a120b] ${isActive ? 'active text-[#1a120b]' : ''}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <Link to="/" className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center">
          <img src="/logo-wordmark.png" alt="Raretto" className="h-8 md:h-9 w-auto" />
          <span className="text-[9px] tracking-[0.4em] text-[#b78d3c] mt-1 text-center">A RARE CHOCOLATE HOUSE</span>
        </Link>

        <div className="flex items-center gap-6">
          <nav className="hidden md:flex items-center gap-8">
            {rightLinks.map((l) => (
              <NavLink key={l.to} to={l.to} className={({ isActive }) => `nav-link tracking-luxe text-[#1a120b]/85 hover:text-[#1a120b] ${isActive ? 'active text-[#1a120b]' : ''}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
          <button className="hidden md:inline-flex" aria-label="Search"><Search className="w-5 h-5 text-[#1a120b]" /></button>
          <button onClick={() => setDrawerOpen(true)} className="relative" aria-label="Cart">
            <ShoppingBag className="w-5 h-5 text-[#1a120b]" />
            {itemCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#b78d3c] text-[#1a120b] rounded-full text-[10px] font-semibold w-4 h-4 flex items-center justify-center">{itemCount}</span>
            )}
          </button>
        </div>
      </div>
    </header>

    {/* Rendered outside <header> deliberately — the header's
        backdrop-blur-md creates a new containing block for `position:
        fixed` descendants, which would make this overlay's `inset-0`
        resolve against the header's own small bounding box instead of
        the viewport, covering only the header's height instead of the
        whole screen. */}
    {mobileOpen && (
      <div className="md:hidden fixed inset-0 z-50 bg-[#1a120b] text-[#f6efe1] p-8">
        <div className="flex justify-between items-center mb-12">
          <img src="/logo-wordmark.png" alt="Raretto" className="h-8 w-auto invert" />
          <button onClick={() => setMobileOpen(false)}><X className="w-6 h-6" /></button>
        </div>
        <nav className="flex flex-col gap-6">
          {allLinks.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setMobileOpen(false)} className="font-display text-3xl">{l.label}</NavLink>
          ))}
        </nav>
      </div>
    )}
    </>
  );
};

export default Navbar;
